import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { TspPaymentStep } from '@entities/payment'
import { useCyberStore } from '@entities/tsp'

export const useFromOtp = () => {
  const [fromOTP, setFromOTP] = useState<boolean>(false)

  const router = useRouter()
  const { step, setStep } = useCyberStore()

  useEffect(() => {
    if (step === TspPaymentStep.PAYMENT_OTP) {
      setFromOTP(true)
    } else {
      setFromOTP(false)
    }
  }, [step])

  useEffect(() => {
    if (fromOTP) {
      setStep(TspPaymentStep.SERVICES_FORM)
    }
  }, [router.asPath])
}
